<template>
  <div class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50 transition-opacity duration-300">
    <div class="relative w-full max-w-3xl bg-gray-800 text-white rounded-lg shadow-xl p-5 flex flex-col gap-4">
      <button
        @click="$emit('close')"
        class="absolute top-4 right-4 text-gray-400 hover:text-indigo-300 transition-colors duration-200"
      >
        <i class="fas fa-times text-lg"></i>
      </button>
      <h3 class="text-xl font-semibold text-indigo-300 flex items-center">
        <i class="fas fa-info-circle mr-2 text-sm"></i> รายละเอียด {{ displayPowerName }}
      </h3>
      <div class="space-y-3">
        <div
          v-if="breakdown.base > 0"
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-calculator text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">ค่าพื้นฐานจากสเตตัส:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.base) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-shirt text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากไอเทม:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.item) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-star text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากโบนัสเซ็ต:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.bonus) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-book text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากทักษะ:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.skill) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-user text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากลักษณะนิสัย:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.trait) }}</span>
        </div>
        <div
          v-if="breakdown.tattoo > 0"
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-paint-brush text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากรอยสัก:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.tattoo) }}</span>
        </div>
        <div
          v-if="breakdown.ghost > 0"
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-ghost text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากวิญญาณ:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.ghost) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-crown text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">จากฉายา:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.title) }}</span>
        </div>
        <div
          v-if="breakdown.carryover > 0"
          class="flex items-center space-x-2 bg-gray-700 border border-gray-600 p-2 rounded-md transition-all duration-200 hover:bg-gray-600 hover:border-indigo-400"
        >
          <i class="fas fa-plus-circle text-indigo-400 text-sm"></i>
          <span class="flex-1 text-sm text-indigo-200">โบนัสจากการรวมสเตตัส:</span>
          <span class="font-semibold text-sm text-indigo-200">{{ formatValue(breakdown.carryover) }}</span>
        </div>
        <div
          class="flex items-center space-x-2 bg-indigo-600 p-2 rounded-md transition-all duration-200"
        >
          <i class="fas fa-star text-white text-sm"></i>
          <span class="flex-1 text-sm font-semibold text-white">รวม:</span>
          <span class="font-semibold text-sm text-white">{{ formatValue(breakdown.total) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PowerDetailsModal',
  props: {
    powerName: {
      type: String,
      required: true,
    },
    breakdown: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayPowerName() {
      const names = {
        maxHp: 'พลังชีวิตสูงสุด',
        atk: 'พลังโจมตี',
        critical: 'คริติคอล',
        evasion: 'หลบหลีก',
        flee: 'หนีซอมบี้',
        defense: 'พลังป้องกัน',
        criticalReduction: 'ลดคริติคอล',
        dropRateBonus: 'โบนัสดรอป',
        damageReduction: 'ลดดาเมจ',
      };
      return names[this.powerName] || this.powerName;
    },
  },
  methods: {
    formatValue(value) {
      if (['critical', 'evasion', 'criticalReduction', 'dropRateBonus', 'damageReduction', 'flee'].includes(this.powerName)) {
        return `${Number(value).toFixed(2)}%`;
      }
      return Math.round(value) || 0;
    },
  },
};
</script>

<style scoped>
button:not(:disabled):active {
  transform: scale(0.98);
}
</style>